import * as React from 'react';
import * as Redux from 'react-redux';
import { FormControl, InputLabel, MenuItem, Select } from '@mui/material';
import * as CONST from '../../../../constants/FieldsConst';
import { allDeportesAction } from '../DeportesAction';

const SelectFieldDeportesComponent = ({
  onChange,
  value,
  data,
  required = false,
  selects = [],
}) => {
  const dispatch = Redux.useDispatch();

  const deportesStore = Redux.useSelector((state) => state.deportes);

  const [deportes, setDeportes] = React.useState([]);

  const _handlerSelects = () => {
    let items = [];
    if (selects.length > 0) {
      deportesStore.all.forEach((se) => {
        const existSeletc = selects.some((item) => item.id === se.id);
        if (!existSeletc) items.push(se);
      });
      setDeportes(items);
    } else {
      if (data) {
        setDeportes(data);
      } else {
        setDeportes(deportesStore.all);
      }
    }
  };

  React.useEffect(() => {
    const fetchData = async () => {
      if (!data && deportesStore.all && deportesStore.all.length === 0) {
        await allDeportesAction(dispatch, null);
      }
    };

    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // eslint-disable-next-line react-hooks/exhaustive-deps
  React.useEffect(async () => _handlerSelects(), [selects]);

  return (
    <FormControl fullWidth size="small" required={required}>
      <InputLabel id={`label_${CONST.deporte.name}`}>
        {CONST.deporte.label}
      </InputLabel>
      <Select
        id={CONST.deporte.name}
        value={value}
        labelId={`label_${CONST.deporte.name}`}
        label={CONST.deporte.label}
        onChange={(e) => onChange(e.target.value)}
      >
        {deportes.map((el, index) => {
          return (
            <MenuItem key={`deporte-${index}`} value={el.id}>
              {el.nombre}
            </MenuItem>
          );
        })}
      </Select>
    </FormControl>
  );
};

export default SelectFieldDeportesComponent;
